import { ErrorsType } from '@src/types/errors';

import { LoadersType } from '@modules/builders';
import { EPaymentStatuses } from '@modules/transactions/types';

import { asyncActions } from './actions';
import { GETBuyRateResponse } from './types';

export type BuyStateType = {
  loaders: LoadersType<typeof asyncActions>;
  errors: ErrorsType;
  buyId?: string;
  buyToken?: string;
  buyStatus?: EPaymentStatuses;
  subtotal?: GETBuyRateResponse['subtotal'];
  cvv: string;
};

export const initialState: BuyStateType = {
  loaders: {},
  errors: {},
  cvv: '',
};

export default initialState;
